export enum ManageParamSourceTypes {
  Node = 'node',
  Workflow = 'workflow',
}
